export default __webpack_public_path__ + "static/media/closed.5bcc19a9.png";